package one.healthium.featureconfig.domain

class FeatureConfigInteractor internal constructor(
    private val repository: FeatureConfigRepository,
) {
    suspend fun <T> get(key: ConfigKey<T>): T = repository.get(key)

    suspend fun isEnabled(key: ConfigKey<Boolean>): Boolean = get(key)
}
